import * as Yup from "yup";

export function initialValues(item) {
  return {
    title: item?.title || "",
    description: item?.description || "",
    nature: item?.nature || null,
    driver: item?.driver || null,
    horizon: item?.horizon || null,
    vulnerablePercent: item?.vulnerablePercent ?? "",
    probability: item?.probability || null,
    severity: item?.severity || null,
    controls: item?.controls || "",
    action: item?.action || "",
  };
}

export function validationSchema(t) {
  return Yup.object({
    title: Yup.string().required(t("required_field")),
    nature: Yup.string().required(t("required_field")),
    probability: Yup.number().min(1).max(5).required(t("required_field")),
    severity: Yup.number().min(1).max(5).required(t("required_field")),
    vulnerablePercent: Yup.number()
      .min(0, t("risk_matrix_ifrs_vuln_range"))
      .max(100, t("risk_matrix_ifrs_vuln_range"))
      .nullable()
      .test(
        "required-if-physical",
        t("risk_matrix_ifrs_vuln_required"),
        function (value) {
          const isPhysical = (this.parent.nature || "").startsWith("Físico");
          return !isPhysical || (value !== null && value !== undefined && value !== "");
        }
      ),
  });
}
